module.exports = __webpack_public_path__ + "select-arrows-ae2d2e0805eaeca25bc024c5d2ff02d4.svg";